"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaginationUtils = void 0;
const DEFAULT_PAGE = 1;
const DEFAULT_LIMIT = 10;
class PaginationUtils {
    static computeOffset(params) {
        const page = PaginationUtils.deducePage(params);
        return (page - 1) * PaginationUtils.deduceLimit(params);
    }
    static deducePage(params) {
        if (!params.page || params.page <= 0) {
            return DEFAULT_PAGE;
        }
        return params.page;
    }
    static deduceLimit(params) {
        if (!params.limit || params.limit <= 0) {
            return DEFAULT_LIMIT;
        }
        return params.limit;
    }
}
exports.PaginationUtils = PaginationUtils;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicGFnaW5hdGlvbi51dGlscy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy91dGlscy9wYWdpbmF0aW9uLXV0aWxzL3BhZ2luYXRpb24udXRpbHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEsTUFBTSxZQUFZLEdBQUcsQ0FBQyxDQUFBO0FBQ3RCLE1BQU0sYUFBYSxHQUFHLEVBQUUsQ0FBQTtBQU14QixNQUFhLGVBQWU7SUFDMUIsTUFBTSxDQUFDLGFBQWEsQ0FBQyxNQUF3QjtRQUMzQyxNQUFNLElBQUksR0FBRyxlQUFlLENBQUMsVUFBVSxDQUFDLE1BQU0sQ0FBQyxDQUFBO1FBQy9DLE9BQU8sQ0FBQyxJQUFJLEdBQUcsQ0FBQyxDQUFDLEdBQUcsZUFBZSxDQUFDLFdBQVcsQ0FBQyxNQUFNLENBQUMsQ0FBQTtJQUN6RCxDQUFDO0lBRU8sTUFBTSxDQUFDLFVBQVUsQ0FBQyxNQUF3QjtRQUNoRCxJQUFJLENBQUMsTUFBTSxDQUFDLElBQUksSUFBSSxNQUFNLENBQUMsSUFBSSxJQUFJLENBQUMsRUFBRSxDQUFDO1lBQ3JDLE9BQU8sWUFBWSxDQUFBO1FBQ3JCLENBQUM7UUFDRCxPQUFPLE1BQU0sQ0FBQyxJQUFJLENBQUE7SUFDcEIsQ0FBQztJQUVPLE1BQU0sQ0FBQyxXQUFXLENBQUMsTUFBd0I7UUFDakQsSUFBSSxDQUFDLE1BQU0sQ0FBQyxLQUFLLElBQUksTUFBTSxDQUFDLEtBQUssSUFBSSxDQUFDLEVBQUUsQ0FBQztZQUN2QyxPQUFPLGFBQWEsQ0FBQTtRQUN0QixDQUFDO1FBQ0QsT0FBTyxNQUFNLENBQUMsS0FBSyxDQUFBO0lBQ3JCLENBQUM7Q0FDRjtBQW5CRCwwQ0FtQkMifQ==